// extracted by mini-css-extract-plugin
module.exports = {"badge":"PaymentTable_badge_1Fj3s","actions":"PaymentTable_actions_230Ry"};